import React, { useState, useEffect } from 'react';
import api from '../api/api';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import Usa from '../assets/UsaFlag.png';
import ToastMessage from '../utils/muitoast';
import { useSelector } from 'react-redux';
import { acessPrivilages, sidebarListItems, notificationPrivilages } from '../utils/sidebarList';
import { useLocation } from 'react-router-dom';
import ConfirmDiscardModal from './discardmodal';

const AddUserModal = ({ isOpen, onClose, onSave, editUser, existingUsers = [], showToast }) => {
  const [roles, setRoles] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [allDevices, setAllDevices] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
   const [token, setToken] = useState(null);
  const [initialData, setInitialData] = useState(null); // NEW
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [errors, setErrors] = useState({});
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [countryCode, setCountryCode] = useState('+1');
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
    const location = useLocation();
const [selectedPermissions, setSelectedPermissions] = useState([]);
let adminpermissions=['1','2','3','4','5','6','7','8','9','10','11','12','13','14']
let supervisorpermissions=['1','5','6','2','3','13',]
let projectmanagerpermission=['1','5','6','13']
  const [alertMessage, setAlertMessage] = useState("");

  // ---- Phone OTP verification (same flow as Subcontractor) ----
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpDigits, setOtpDigits] = useState(["", "", "", ""]);
  const [otpError, setOtpError] = useState("");
  const [otpResendTimer, setOtpResendTimer] = useState(0);
  const [otpSending, setOtpSending] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const otpInputsRef = React.useRef([]);

  const hasUnsavedChanges = () => {
  if (!isEditMode || !initialData) return false;
  return JSON.stringify(formData) !== JSON.stringify(initialData);
};

  const user = useSelector((state) => state.user.userDetails);
   useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      const accessToken = queryParams.get('allow');
   
      if (accessToken) {
        setToken(accessToken);
   
      }

    }, [location.search]);
 console.log(editUser,user)
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    username: '',
    password: '',
    phone: '',
    email: '',
    newPin: '',
    confirmPin: '',
    gender: '',
    status: '',
    role: '',
    ipadids: [''],
    companyid: '',
  });
useEffect(() => {
  // Don't override permissions if editing a user who already has permissions
  if (isEditMode && editUser?.user_info?.permissions?.length > 0) return;

  const selectedRoleObj = roles.find(role => role.id === Number(formData.role));
  const roleName = selectedRoleObj?.role;

  if (roleName === 'Admin' || roleName === 'Super Admin') {
    setSelectedPermissions(adminpermissions);
  } else if (roleName === 'Supervisor') {
    setSelectedPermissions(supervisorpermissions);
  } else if (roleName === 'Project Manager') {
    setSelectedPermissions(projectmanagerpermission);
  } else {
    setSelectedPermissions([]);
  }
}, [formData.role, roles, isEditMode, editUser]);


  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      fetchRoles();
      fetchCompanies();
      fetchDevices();
if (editUser) {
  // If permissions already exist for user (previously saved)
  if (editUser?.user_info?.permissions?.length > 0) {
    setSelectedPermissions(editUser.user_info.permissions);
  } 
  // Otherwise auto-select based on their role
  else if (['Admin', 'Super Admin'].includes(editUser.user_roles?.role) || ['Admin', 'Super Admin'].includes(editUser.role_name)) {
    setSelectedPermissions(adminpermissions);
  } else if (editUser.user_roles?.role === 'Supervisor' || editUser.role_name === 'Supervisor') {
    setSelectedPermissions(supervisorpermissions);
  } else if (editUser.user_roles?.role === 'Project Manager' || editUser.role_name === 'Project Manager') {
    setSelectedPermissions(projectmanagerpermission);
  } else {
    setSelectedPermissions([]);
  }
} else {
  setSelectedPermissions([]);
}


      if (editUser) {
        setIsEditMode(true);
        const phone = editUser.phone || '';
        const codeMatch = phone.match(/^(\+\d+)/);
        const code = codeMatch ? codeMatch[1] : '+1';
        setCountryCode(code);

        const updatedForm = {
          firstname: editUser.firstname || '',
          lastname: editUser.lastname || '',
          username: editUser.username,
          password: '',
          phone: phone.replace(/^\+\d+\s?/, ''),
          email: editUser.email || '',
          newPin: '',
          confirmPin: '',
          gender: editUser.gender === 'M' ? 'Male' : editUser.gender === 'F' ? 'Female' : 'Other',
          status: editUser.status === 'A' ? 'Active' : 'Inactive',
          role: editUser.role_id || '',
          ipadids: Array.isArray(editUser.ipadid)
            ? editUser.ipadid.map(id => id.trim())
            : typeof editUser.ipadid === 'string'
              ? editUser.ipadid.split(',').map(id => id.trim())
              : [],
          companyid: editUser.user_role === 'Project Manager'||editUser.user_role === 'Supervisor'
            ? editUser?.user_info?.company_id
            : editUser?.companyid || '',
        };

        setFormData(updatedForm);
        setInitialData(updatedForm); // Save initial data for comparison
      } else {
        setIsEditMode(false);
        const emptyData = {
          firstname: '',
          lastname: '',
          username: '',
          password: '',
          phone: '',
          email: '',
          newPin: '',
          confirmPin: '',
          gender: '',
          status: '',
          role: '',
          ipadids: [''],
          companyid: '',
        };
        setFormData(emptyData);
        setInitialData(null); // Clear
      }

      setErrors({});
      // New user: phone must be verified. Edit: the existing phone is
      // already trusted — only a CHANGE to it requires re-verification.
      setPhoneVerified(!!editUser);
      setShowOtpModal(false);
      setOtpDigits(["", "", "", ""]);
      setOtpError("");
      setOtpResendTimer(0);
    }
  }, [isOpen, editUser]);

  // Resend countdown timer.
  useEffect(() => {
    if (otpResendTimer <= 0) return;
    const t = setTimeout(() => setOtpResendTimer((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [otpResendTimer]);

  const fetchRoles = async () => {
    try {
      const response = await api.get('/v1/roles', {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });
      setRoles(response.data);
    } catch (error) {
      console.error('Failed to fetch roles:', error);
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await api.get(`/v1/timesheets/company-details`);
      if (response.status === 200) {
        setCompanies(response.data);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const fetchDevices = async () => {
    try {
      const response = await api.get("/v1/devices/available");
      if (response.status === 200) {
        setAllDevices(response.data);
      }
    } catch (error) {
      console.error("Error fetching devices:", error);
    }
  };

  const getAvailableDevices = (currentId) => {
    return allDevices.filter(device => {
      const match = device.device_uid.match(/\d+$/);
      if (!match) return false;
      return (
        !formData.ipadids.includes(device.device_uid) ||
        device.device_uid === currentId
      );
    });
  };

  const getPasswordRules = (password = '') => ([
    { label: '8+ characters', valid: password.length >= 8 },
    { label: '1 uppercase letter', valid: /[A-Z]/.test(password) },
    { label: '1 lowercase letter', valid: /[a-z]/.test(password) },
    { label: '1 number', valid: /\d/.test(password) },
    { label: '1 special character', valid: /[^A-Za-z0-9]/.test(password) },
    { label: 'No spaces', valid: password.length > 0 && !/\s/.test(password) },
  ]);

  const getPasswordError = (password) => {
    if (!password) return '';
    if (password.length < 8) return 'Password must be at least 8 characters';
    if (/\s/.test(password)) return 'Password must not contain spaces';
    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])/.test(password)) {
      return 'Password must include uppercase, lowercase, number and special character';
    }
    return '';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      // Allow only digits, max 10
      const digitsOnly = value.replace(/\D/g, '').slice(0, 10);
      setFormData(prev => ({ ...prev, phone: digitsOnly }));
      if (errors.phone) setErrors(prev => ({ ...prev, phone: '' }));
      // In edit mode the phone is only un-verified if it differs from the
      // original; reverting to the original clears the need to verify again.
      // In create mode any change always needs verification.
      if (editUser && digitsOnly === (initialData?.phone ?? '')) {
        setPhoneVerified(true);
      } else {
        setPhoneVerified(false);
      }
      return;
    }
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === 'password') {
      setErrors(prev => ({ ...prev, password: getPasswordError(value) }));
    } else if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  // Flag a duplicate username as soon as the field loses focus.
  const handleUsernameBlur = () => {
    const value = formData.username.trim();
    if (!value) return;
    const duplicate = existingUsers.some(
      (u) =>
        u.username &&
        u.username.trim().toLowerCase() === value.toLowerCase() &&
        u.id !== editUser?.id // exclude the user being edited
    );
    if (duplicate) {
      setErrors(prev => ({ ...prev, username: 'Username already exists' }));
    }
  };

  // ---- OTP handlers ----
  const handleSendPhoneOtp = async () => {
    if (!/^\d{10}$/.test(formData.phone)) {
      setErrors(prev => ({ ...prev, phone: 'Enter a valid 10-digit phone number' }));
      return;
    }
    setOtpSending(true);
    setOtpError('');
    try {
      const resp = await api.post('/v1/users/send-otp', {
        phone_number: formData.phone,
      });
      if (resp.status === 200) {
        setShowOtpModal(true);
        setOtpDigits(['', '', '', '']);
        setOtpResendTimer(59);
        setTimeout(() => otpInputsRef.current[0]?.focus(), 50);
      } else {
        setOtpError(resp.message || 'Failed to send OTP');
      }
    } catch (error) {
      console.error('Failed to send OTP:', error);
      setOtpError(error?.response?.data?.message || 'Failed to send OTP');
    } finally {
      setOtpSending(false);
    }
  };

  const handleOtpDigitChange = (idx, val) => {
    const digit = val.replace(/\D/g, '').slice(-1);
    const next = [...otpDigits];
    next[idx] = digit;
    setOtpDigits(next);
    if (digit && idx < 3) otpInputsRef.current[idx + 1]?.focus();
  };

  const handleOtpDigitKeyDown = (idx, e) => {
    if (e.key === 'Backspace' && !otpDigits[idx] && idx > 0) {
      otpInputsRef.current[idx - 1]?.focus();
    }
  };

  const handleVerifyPhoneOtp = async () => {
    const code = otpDigits.join('');
    if (code.length !== 4) {
      setOtpError('Enter the 4-digit code');
      return;
    }
    setOtpVerifying(true);
    setOtpError('');
    try {
      const resp = await api.post('/v1/users/validate-otp', {
        phone_number: formData.phone,
        otp: code,
      });
      if (resp.status === 200 && resp.verified) {
        setPhoneVerified(true);
        setShowOtpModal(false);
        setSeverity('success');
        setAlertMessage('Phone number verified');
        setOpen(true);
      } else {
        setOtpError(resp.message || 'Invalid OTP');
      }
    } catch (error) {
      console.error('Failed to verify OTP:', error);
      setOtpError(error?.response?.data?.message || 'Invalid OTP');
    } finally {
      setOtpVerifying(false);
    }
  };

  const handleIpadChange = (index, value) => {
    const updated = [...formData.ipadids];
    updated[index] = value;
    setFormData(prev => ({ ...prev, ipadids: updated }));
  };

  const addIpadField = () => {
    const availableDevices = allDevices.filter(d => !formData.ipadids.includes(d.device_uid));
    if (availableDevices.length > 0) {
      setFormData(prev => ({ ...prev, ipadids: [...prev.ipadids, ''] }));
    }else{
      setSeverity("info");
        setAlertMessage("No Ipads Available");
        setOpen(true);
    }
  };

  const removeIpadField = (index) => {
    const updated = [...formData.ipadids];
    updated.splice(index, 1);
    setFormData(prev => ({ ...prev, ipadids: updated }));
  };

  const validateForm = () => {
  let newErrors = {};

  if (!formData.firstname) newErrors.firstname = 'Firstname is required';
  if (!formData.lastname) newErrors.lastname = 'Lastname is required';
  if (!formData.username) {
    newErrors.username = 'Username is required';
  } else {
    const duplicate = existingUsers.some(
      (u) =>
        u.username &&
        u.username.trim().toLowerCase() === formData.username.trim().toLowerCase() &&
        u.id !== editUser?.id // exclude the user being edited
    );
    if (duplicate) newErrors.username = 'Username already exists';
  }

  if (!isEditMode && !formData.password) {
    newErrors.password = 'Password is required';
  } else if (formData.password) {
    const passwordError = getPasswordError(formData.password);
    if (passwordError) newErrors.password = passwordError;
  }

  if (!formData.phone) {
    newErrors.phone = 'Phone number is required';
  } else if (!/^\d{10}$/.test(formData.phone)) {
    newErrors.phone = 'Phone number must be 10 digits';
  }

  if (!formData.email) {
    newErrors.email = 'Email is required';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    newErrors.email = 'Invalid email address';
  }

  if (!isEditMode && !formData.newPin) {
    newErrors.newPin = 'PIN is required';
  } else if (!isEditMode && formData.newPin.length < 4) {
    newErrors.newPin = 'PIN must be at least 4 digits';
  }

  if (!isEditMode && formData.newPin !== formData.confirmPin) {
    newErrors.confirmPin = 'PINs do not match';
  }

  if (!formData.gender) newErrors.gender = 'Gender is required';
  if (!formData.status) newErrors.status = 'Status is required';
  if (!formData.role) newErrors.role = 'Role is required';

  const selectedRole = roles.find(role => role.id === Number(formData.role));
  if (selectedRole?.role === 'Project Manager' && !formData.companyid) {
    newErrors.companyid = 'Company is required for Project Manager';
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0; // ✅ valid if no errors
};


  const getUpdatedFields = () => {
    if (!initialData) return {}; // fallback

    const updatedFields = {};
    const mapGender = (g) => (g === 'Male' ? 'M' : g === 'Female' ? 'F' : 'O');
    const mapStatus = (s) => (s === 'Active' ? 'A' : 'I');

    Object.keys(initialData).forEach((key) => {
      const current = formData[key];
      const initial = initialData[key];

      if (key === 'gender' && mapGender(current) !== editUser.gender) {
        updatedFields[key] = mapGender(current);
      } else if (key === 'status' && mapStatus(current) !== editUser.status) {
        updatedFields[key] = mapStatus(current);
      } else if (key === 'ipadids') {
        const cleanedCurrent = current.map(id => id.trim()).filter(Boolean);
        const cleanedInitial = initial.map(id => id.trim()).filter(Boolean);
        if (JSON.stringify(cleanedCurrent) !== JSON.stringify(cleanedInitial)) {
          updatedFields.ipadid = cleanedCurrent;
        }
      } else if (key === 'companyid') {
        if (current && current !== initial) {
          updatedFields.user_info = { company_id: current };
        }
      } else if (current !== initial) {
        updatedFields[key] = current;
      }
    });

    if (formData.password) updatedFields.password = formData.password;
    if (formData.newPin) updatedFields.mpin = formData.newPin;

    return updatedFields;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (!phoneVerified) {
      setErrors(prev => ({ ...prev, phone: 'Please verify the phone number' }));
      setSeverity('info');
      setAlertMessage('Please verify the phone number with OTP');
      setOpen(true);
      return;
    }
if(selectedPermissions.length===0){
       setSeverity("info");
        setAlertMessage("Please select Privilages");
        setOpen(true);
  return
}
    try {
   
      const canManagePermissions = ['Admin', 'Super Admin'].includes(user?.user_roles?.role);

      let userData;
      if (isEditMode && editUser) {
        userData = getUpdatedFields();
        // Send permission changes inside the same payload so they go through
        // the Super Admin approval flow together with the rest of the edit.
        if (canManagePermissions) {
          const oldPermissions = editUser.user_info?.permissions || [];
          const newPermissions = selectedPermissions || [];
          const permissionsChanged =
            oldPermissions.length !== newPermissions.length ||
            oldPermissions.some((id) => !newPermissions.includes(id));
          if (permissionsChanged) {
            userData.user_info = { ...(userData.user_info || {}), permissions: newPermissions };
          }
        }
      } else {
        userData = {
          firstname: formData.firstname,
          lastname: formData.lastname,
          username: formData.username,
          password: formData.password,
          mpin: formData.newPin,
          phone: formData.phone,
          email: formData.email,
          gender: formData.gender === 'Male' ? 'M' : formData.gender === 'Female' ? 'F' : 'O',
          status: formData.status === 'Active' ? 'A' : 'I',
          role: formData.role,
          ipadid: formData.ipadids.filter(Boolean),
          ...(formData.companyid && { user_info: { company_id: formData.companyid } }),
        };
      }

      const response = isEditMode
        ? await api.put(`/v1/users/${editUser.id}`, userData)
        : await api.post('/v1/users', userData);

      // The edit needs Super Admin approval — nothing is applied yet
      if (response.status === 202) {
        onClose();
        showToast(response.message || 'Request sent to Super Admin for approval', 'info');
        return;
      }

    // For NEW users, permissions are saved with a follow-up call
    // (edit-mode permission changes travel inside the PUT payload above)
    if (!isEditMode && canManagePermissions && response.status==200) {
      const userId = response.data.id;
      const newPermissions = selectedPermissions || [];
      if (newPermissions.length > 0) {
        await api.put(`/v1/users/${userId}/user-info`, {
          permissions: newPermissions,
        });
      }
    }
      if (response.status === 200) {
        onSave(response.data, isEditMode);
        onClose();
        showToast(isEditMode ? 'User updated successfully' : 'User created successfully');
        if(user?.id===editUser?.id){
      window.location.reload();    
        }


      } else {
         if (response.message?.toLowerCase().includes("email")) {
        setErrors(prev => ({ ...prev, email: response.message })); // 🔴 email error
      } else if (response.message?.toLowerCase().includes("phone")) {
        setErrors(prev => ({ ...prev, phone: response.message })); // 🔴 phone error
      } else if (response.message?.toLowerCase().includes("username")) {
        setErrors(prev => ({ ...prev, username: response.message })); // 🔴 username error
      } else {
        setSeverity("info");
        setAlertMessage(response?.message || "Something Went Wrong");
        setOpen(true);
      }
      }
    } catch (error) {
      console.error('Failed to save user:', error);
      setSeverity("error");
      setAlertMessage("Something went wrong");
      setOpen(true);
    }
  };
  const isInactive = formData.status === "Inactive" || formData.status === "I";


  const selectedRole = roles.find(role => role.id === Number(formData.role));
useEffect(()=>console.log(selectedRole,'selectedrole'),[selectedRole])
  if (!isOpen) return null;

  return (
<div className="absolute inset-0 bg-black bg-opacity-50 z-50 overflow-y-auto">
  <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl mx-auto my-8 p-6 relative">
        <h2 className='text-xl text-left font-inter font-semibold mb-4'>{isEditMode ? 'Edit User' : 'Add New User'}</h2>

        <form onSubmit={handleSubmit}>
          <div className='grid grid-cols-2 gap-4'>
            {/* Firstname */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Firstname<span className="text-red-500 ml-0.5">*</span></label>
              <input
                name="firstname"
                value={formData.firstname}
                disabled={isInactive}
                onChange={handleChange}
                className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.firstname ? 'border-red-500' : ''}`}
                placeholder='Firstname'
              />
              {errors.firstname && <p className="text-red-500 text-xs mt-1">{errors.firstname}</p>}
            </div>

            {/* Lastname */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Lastname<span className="text-red-500 ml-0.5">*</span></label>
              <input
                name="lastname"
                value={formData.lastname}
                disabled={isInactive}
                onChange={handleChange}
                className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.lastname ? 'border-red-500' : ''}`}
                placeholder='Lastname'
              />
              {errors.lastname && <p className="text-red-500 text-xs mt-1">{errors.lastname}</p>}
            </div>

            {/* Username */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Username<span className="text-red-500 ml-0.5">*</span></label>
              <input
                name="username"
                autoComplete='off'
                value={formData.username}
                onChange={handleChange}
                onBlur={handleUsernameBlur}
                disabled={isInactive}
                className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.username ? 'border-red-500' : ''}`}
                placeholder='Username'
              />
              {errors.username && <p className="text-red-500 text-xs mt-1">{errors.username}</p>}
            </div>

            {/* Password */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Password{!isEditMode && <span className="text-red-500 ml-0.5">*</span>}</label>
              <input
                type='password'
               autoComplete="new-password"  
                name="password"
                value={formData.password}
                disabled={isInactive}
                onChange={handleChange}
                onFocus={() => setPasswordFocused(true)}
                onBlur={() => setPasswordFocused(false)}
                className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.password ? 'border-red-500' : ''}`}
                placeholder='Password'
              />

              {(passwordFocused || formData.password) && (
                <div className="mt-2 rounded-lg border border-gray-200 bg-gray-50 p-3">
                  <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-2">
                    Password must contain
                  </p>
                  <div className="grid grid-cols-2 gap-x-3 gap-y-1.5">
                    {getPasswordRules(formData.password).map((rule) => (
                      <div
                        key={rule.label}
                        className={`flex items-center gap-1.5 text-xs transition-colors ${
                          rule.valid ? 'text-green-600' : 'text-gray-400'
                        }`}
                      >
                        <span
                          className={`flex h-4 w-4 items-center justify-center rounded-full text-[10px] transition-colors ${
                            rule.valid
                              ? 'bg-green-100 text-green-600'
                              : 'bg-gray-200 text-gray-400'
                          }`}
                        >
                          {rule.valid ? '✓' : '•'}
                        </span>
                        {rule.label}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Phone with Country Code */}
            <div>
  <label className='font-Font1 font-semibold text-[15px] flex'>Phone<span className="text-red-500 ml-0.5">*</span></label>
  <div className="flex">
    <div className="flex items-center justify-center px-3 py-1 border border-r-0 rounded-l bg-gray-50">
    <img src={Usa} className="mr-1" style={{ width: '25px', height: 'auto' }} />
      <span>+1</span>
    </div>
    <input
      name="phone"
      value={formData.phone}
      onChange={handleChange}
      disabled={isInactive}
      className={`w-full border px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.phone ? 'border-red-500' : ''}`}
      placeholder='Enter phone number'
    />
    {phoneVerified ? (
      <span className="flex items-center px-3 py-1 border border-l-0 rounded-r bg-green-50 text-green-600 text-sm whitespace-nowrap">
        ✓ Verified
      </span>
    ) : (
      <button
        type="button"
        onClick={handleSendPhoneOtp}
        disabled={isInactive || otpSending || !/^\d{10}$/.test(formData.phone)}
        className="px-3 py-1 border border-l-0 rounded-r bg-gray-900 text-white text-sm whitespace-nowrap hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {otpSending ? 'Sending...' : 'Verify'}
      </button>
    )}
  </div>
  {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
</div>

            {/* Email */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Email<span className="text-red-500 ml-0.5">*</span></label>
              <input
                name="email"
                type="email"
                value={formData.email}
                disabled={isInactive}
                onChange={handleChange}
                className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.email ? 'border-red-500' : ''}`}
                placeholder='Email'
              />
              {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
            </div>
{/* New PIN */}
<div>
  <label className='font-Font1 font-semibold text-[15px] flex'>New PIN{!isEditMode && <span className="text-red-500 ml-0.5">*</span>}</label>
  <input
    name="newPin"
    type="password"
    value={formData.newPin}
    onChange={handleChange}
    maxLength="4"
disabled={isInactive}
    className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.newPin ? 'border-red-500' : ''}`}
    placeholder='4-digit PIN'
  />
  {errors.newPin && <p className="text-red-500 text-xs mt-1">{errors.newPin}</p>}
</div>

{/* Confirm PIN */}
<div>
  <label className='font-Font1 font-semibold text-[15px] flex'>Confirm PIN{!isEditMode && <span className="text-red-500 ml-0.5">*</span>}</label>
  <input
    name="confirmPin"
    type="password"
    value={formData.confirmPin}
    onChange={handleChange}
    maxLength="4"
disabled={isInactive}
    className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.confirmPin ? 'border-red-500' : ''}`}
    placeholder='Confirm PIN'
  />
  {errors.confirmPin && <p className="text-red-500 text-xs mt-1">{errors.confirmPin}</p>}
</div>


            {/* Gender */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Gender<span className="text-red-500 ml-0.5">*</span></label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                disabled={isInactive}
                className={`w-full border cursor-pointer rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.gender ? 'border-red-500' : ''}`}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
              {errors.gender && <p className="text-red-500 text-xs mt-1">{errors.gender}</p>}
            </div>

            {/* Status */}
            <div  >
              <label className='font-Font1 font-semibold text-[15px] flex'>Status<span className="text-red-500 ml-0.5">*</span></label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                
                className={`w-full border cursor-pointer rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.status ? 'border-red-500' : ''}`}
              >
                <option value=""> Select Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
              {errors.gender && <p className="text-red-500 text-xs mt-1">{errors.status}</p>}
            </div>

            {/* Role (required) */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Roles<span className="text-red-500 ml-0.5">*</span></label>
              <select
                name="role"
                value={formData.role}
                disabled={isInactive}
                onChange={handleChange}
                className={`w-full border cursor-pointer rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.role ? 'border-red-500' : ''}`}
              >
                <option value="">Select Role</option>
                {roles.map(role => (
                  <option key={role.id} value={role.id}>
                    {role.role}
                  </option>
                ))}
              </select>
              {errors.role && <p className="text-red-500 text-xs mt-1">{errors.role}</p>}
            </div>

            {/* iPad ID */}
         <div className="col-span-2 mb-4">
          <label className='font-Font1 font-semibold text-[15px] flex mb-1'> Assigned iPad's</label>
          {formData.ipadids.map((id, index) => (
            <div key={index} className="flex items-center mb-2">
      <select
  value={formData.ipadids[index] || ""}
  onChange={(e) => {
    const updatedIpadids = [...formData.ipadids];
    updatedIpadids[index] = e.target.value;
    setFormData({ ...formData, ipadids: updatedIpadids });
  }}
  className="w-full border px-2 py-1 rounded  "
>
  <option value="" disabled>Select iPad</option>

  {/* Always include the current selected value */}
  {formData.ipadids[index] && !allDevices.some(d => d.device_uid === formData.ipadids[index]) && (
    <option value={formData.ipadids[index]}>
      {formData.ipadids[index]} 
    </option>
  )}

  {getAvailableDevices(formData.ipadids[index]).map((device) => (
    <option key={device.device_uid} value={device.device_uid}>
      {device.device_uid}
    </option>
  ))}
</select>




              {formData.ipadids.length > 0 && (
                <button
                  type="button"
                  onClick={() => removeIpadField(index)}
                  className="ml-2 text-red-500 font-bold text-xl"
                >
                  ×
                </button>
              )}
            </div>
          ))}
          <button
            type="button"
            onClick={addIpadField}
            disabled={isInactive}
            className="text-sm text-blue-600 mt-1"
          >
            + Add Another iPad
          </button>
          {errors.ipadids && <p className="text-red-500 text-xs mt-1">{errors.ipadids}</p>}
        </div>
            
            {(selectedRole?.role === 'Project Manager' || selectedRole?.role === 'Supervisor') &&(
              <div>
                <label className='font-Font1 font-semibold text-[15px] flex'>Company ID<span className="text-red-500 ml-0.5">*</span></label>
                <select
                  name="companyid"
                  value={formData.companyid}
                  onChange={handleChange}
                  className={`w-full border cursor-pointer rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.companyid ? 'border-red-500' : ''}`}
                >
                  <option value="">Select Company</option>
                  {companies.map(company => (
                    <option key={company.id} value={company.id}>
                      {company.name}
                    </option>
                  ))}
                </select>
                {errors.companyid && <p className="text-red-500 text-xs mt-1">{errors.companyid}</p>}
              </div>
            )}
          </div>
{['Admin', 'Super Admin'].includes(user?.user_roles?.role) && (
  <div className="col-span-2 mt-4 border-t pt-4">
    {/* Sidebar Privileges */}
    <h3 className="font-semibold text-lg mb-3">Sidebar Privileges</h3>
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mb-6">
      {sidebarListItems(token).map((item) => {
        const isChecked = selectedPermissions.includes(item.id);

        const handleCheckboxChange = () => {
          setSelectedPermissions((prev) =>
            prev.includes(item.id)
              ? prev.filter((id) => id !== item.id)
              : [...prev, item.id]
          );
        };

        return (
          <label
            key={item.id}
            className="flex items-center space-x-2 p-2 border rounded-md hover:bg-gray-100 cursor-pointer"
          >
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <span>{item.label}</span>
          </label>
        );
      })}
    </div>

    {/* Access Management Section */}
    {acessPrivilages?.length > 0 && (
      <>
        <h3 className="font-semibold text-lg mb-3">Access Management</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {acessPrivilages.map((item) => {
            const isChecked = selectedPermissions.includes(item.id);

            const handleCheckboxChange = () => {
              setSelectedPermissions((prev) =>
                prev.includes(item.id)
                  ? prev.filter((id) => id !== item.id)
                  : [...prev, item.id]
              );
            };

            return (
              <label
                key={item.id}
                className="flex items-center space-x-2 p-2 border rounded-md hover:bg-gray-100 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <span>{item.label}</span>
              </label>
            );
          })}
        </div>
      </>
    )}

    {/* Notification Privileges */}
    {notificationPrivilages?.length > 0 && (
      <>
        <h3 className="font-semibold text-lg mb-3 mt-4">Notification Privileges</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {notificationPrivilages
            .filter((item) => {
              if (item.roleRestriction) {
                return selectedRole?.role === item.roleRestriction;
              }
              return true;
            })
            .map((item) => {
              const isChecked = selectedPermissions.includes(item.id);

              const handleCheckboxChange = () => {
                setSelectedPermissions((prev) =>
                  prev.includes(item.id)
                    ? prev.filter((id) => id !== item.id)
                    : [...prev, item.id]
                );
              };

              return (
                <label
                  key={item.id}
                  className="flex items-center space-x-2 p-2 border rounded-md hover:bg-gray-100 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <span>{item.label}</span>
                </label>
              );
            })}
        </div>
      </>
    )}
  </div>
)}



          <div className='mt-6 text-right'>
            <button
              type="submit"
              className='bg-red-800 text-white px-4 text-[15px] py-1 font-Font1  rounded hover:bg-red-700'
            >
              {isEditMode ? 'UPDATE' : 'SAVE'}
            </button>
          </div>

        </form>

        <button
          className='absolute top-4 right-4 text-gray-500 hover:text-black text-xl'
          // onClick={onClose}
          onClick={() => {
  if (isEditMode && hasUnsavedChanges()) {
    setShowConfirmModal(true);
  } else {
    onClose();
  }
}}

        >
          <ClearRoundedIcon />
          </button>
      </div>
      {showOtpModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] px-4">
          <div className="bg-white rounded-xl shadow-lg w-full max-w-sm p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-1">Verify Phone Number</h3>
            <p className="text-sm text-gray-500 mb-5">
              Enter the 4-digit code sent to +1 {formData.phone}
            </p>

            <div className="flex justify-center gap-3 mb-4">
              {otpDigits.map((d, i) => (
                <input
                  key={i}
                  ref={(el) => (otpInputsRef.current[i] = el)}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={d}
                  onChange={(e) => handleOtpDigitChange(i, e.target.value)}
                  onKeyDown={(e) => handleOtpDigitKeyDown(i, e)}
                  className="w-12 h-14 text-center text-lg border border-gray-300 rounded-md focus:outline-none focus:border-gray-800"
                />
              ))}
            </div>

            <div className="text-center text-xs text-gray-500 mb-4">
              Didn't receive a code?{' '}
              <button
                type="button"
                onClick={() => {
                  if (otpResendTimer > 0) return;
                  handleSendPhoneOtp();
                }}
                disabled={otpResendTimer > 0}
                className={`underline ${otpResendTimer > 0 ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700'}`}
              >
                Resend Code
                {otpResendTimer > 0 ? ` (0:${otpResendTimer.toString().padStart(2, '0')})` : ''}
              </button>
            </div>

            {otpError && (
              <div className="text-red-600 text-sm mb-3 text-center">{otpError}</div>
            )}

            <button
              type="button"
              onClick={handleVerifyPhoneOtp}
              disabled={otpVerifying}
              className="w-full bg-gray-900 text-white text-sm font-medium py-3 rounded-md hover:bg-gray-800 transition disabled:opacity-60"
            >
              {otpVerifying ? 'Verifying...' : 'Verify'}
            </button>
            <button
              type="button"
              onClick={() => {
                setShowOtpModal(false);
                setOtpDigits(['', '', '', '']);
                setOtpError('');
              }}
              className="w-full mt-3 text-sm text-gray-500 hover:text-gray-700"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      <ConfirmDiscardModal
  open={showConfirmModal}
  onCancel={() => setShowConfirmModal(false)}
  onDiscard={() => {
    setShowConfirmModal(false);
    onClose();   // user confirmed close
  }}
/>

        <ToastMessage
              message={alertMessage}
              severity={severity}
              open={open}
              handleClose={handleCloseToast}
            />
    </div>
  );
};

export default AddUserModal;